export const getInvoiceCustomId = (row) => row?.invoice?.id ?? '—';


export const getLeadName = (row) => row?.invoice?.order?.lead?.name ?? '—';
export const getLeadEmail = (row) => row?.invoice?.order?.lead?.email ?? '—';

export const getErrorMessage = (row) =>
  row?.error ?? row?.message ?? row?.error_message ?? row?.details ?? '—';

export const formatCreatedAt = (row) => {
  const raw = row?.created_at;
  if (!raw) return '—';
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? String(raw) : d.toLocaleString();
};
